import classNames from "classnames";

import { DeviceDefaultIcon } from "@jti/brand-icons/device-default";
import { DevicePhoneIcon } from "@jti/brand-icons/device-phone";
import { LivechatIcon } from "@jti/brand-icons/livechat";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { MailClassicIcon } from "@jti/brand-icons/mail-classic";
import { ProfileDefaultIcon } from "@jti/brand-icons/profile-default";
import { UiInfoCircleBoldIcon } from "@jti/brand-icons/ui-info-circle-bold";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import type { ContactInfoBlockKeys } from "../../ContactBlock";

import styles from "./ContactInfoBlock.module.scss";

const CONTACT_TYPE_ICONS = {
  Phone: DevicePhoneIcon,
  Account: ProfileDefaultIcon,
  Mail: MailClassicIcon,
  Product: DeviceDefaultIcon,
  "Live Chat": LivechatIcon,
  Info: UiInfoCircleBoldIcon,
};

export type ContactInfoBlockProps = {
  contactType: ContactInfoBlockKeys;
  ctaLink: string;
  info?: string;
  additionalInfo?: string;
  isDarkMode?: boolean;
  dispatchGTMEvent?: () => void;
  disablePhoneFormatting?: boolean;
  nativeBehaviour?: boolean;
};

export const ContactInfoBlock = ({
  info,
  additionalInfo,
  ctaLink,
  contactType,
  nativeBehaviour,
}: ContactInfoBlockProps) => {
  const handleClick = () => {
    if (contactType === "Phone") {
      dispatchTrackingEvent(TrackingEvents.TrackingContactUsPhoneClick);
    } else {
      dispatchTrackingEvent(TrackingEvents.TrackingContactUsClick);
    }
  };

  const IconComponent = CONTACT_TYPE_ICONS[contactType];

  return (
    <LinkBehaviour
      className={styles.link}
      href={ctaLink}
      onClick={handleClick}
      data-testid="contact-us-details-info-block"
      rel="noreferrer"
      nativeBehaviour={nativeBehaviour}
    >
      <IconComponent className={styles.infoBlockIcon} />
      <div className={styles.infoSection}>
        {info && (
          <div
            className={classNames(styles.infoBlockSubInfo, { [styles.infoBlockSubInfoPhone]: contactType === "Phone" })}
          >
            {info}
          </div>
        )}
        {additionalInfo && <div className={styles.infoBlockSubAdditionalInfo}>{additionalInfo}</div>}
      </div>
      <LongArrowForwardIcon className={styles.infoBlockCtaIcon} />
    </LinkBehaviour>
  );
};
